import {
  useDeleteArticleReactionMutation,
  useSetArticleReactionMutation,
} from 'rtkQuery/sharespro/queries/articles';

const useSetArticleReaction = (
  articleId: ID,
  selectedReactionId: ID | null,
  page: number
): (reaction: Reaction) => void => {
  const [deleteReaction] = useDeleteArticleReactionMutation();
  const [setReaction] = useSetArticleReactionMutation();

  return (reaction: Reaction) => {
    if (selectedReactionId === reaction.id) {
      deleteReaction({ article_id: articleId, page });
    } else {
      setReaction({
        reaction,
        article_id: articleId,
        page,
      });
    }
  };
};

export default useSetArticleReaction;
